import { cnSimple } from './cn_simple'
import { cnTraditional } from './cn_traditional'
import { en } from './en'

export const messages = {
  'zh-CN': cnSimple,
  'zh-CN-HK': cnTraditional,
  'en-US': en
}
